module.exports = __webpack_public_path__ + "img/default.653f93c3.jpg";